/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type TradePromo_viewer$ref = any;
export type PdpSharedPromoCode_viewer$ref = any;
export type PdpSharedPromoCode_viewer = {
    readonly " $fragmentRefs": TradePromo_viewer$ref;
    readonly " $refType": PdpSharedPromoCode_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedPromoCode_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "TradePromo_viewer",
                    "args": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'f63fa07c219aacd664a081e71e472814';
export default node;
